import { LuWallet } from 'react-icons/lu';
import type { Transaction } from '@/types';
import { SectionCard, Field } from './shared';

/* ─── Financials Tab ─── */

export function FinancialsTab({ transactions }: { transactions: Transaction[] }) {
    if (!transactions || transactions.length === 0) {
        return <p className="py-8 text-center text-[13px] text-[#999]">No transactions recorded for this case.</p>;
    }

    const formatNaira = (n: number) => `₦${Number(n || 0).toLocaleString()}`;
    const formatDateTime = (iso: string) =>
        new Date(iso).toLocaleString('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            day: '2-digit',
            month: 'short',
            year: 'numeric',
        });

    return (
        <div className="space-y-5">
            {transactions.map((tx) => (
                <SectionCard key={tx.id} icon={<LuWallet size={18} className="text-secondary" />} title="Transaction">
                    <div className="grid grid-cols-2 gap-y-4 sm:grid-cols-3">
                        <Field label="Transaction ID" value={tx.transactionId} />
                        <Field label="Date & Time" value={formatDateTime(tx.createdAt)} />
                        <Field label="Amount Paid" value={formatNaira(tx.amountPaid)} />
                        <Field label="Payment Method" value={tx.paymentMethod} />
                    </div>
                </SectionCard>
            ))}
        </div>
    );
}
